import pageView from '@/layout/pageView'
import emptyView from '@/layout/routerView'

// 新闻中心
import newsCenter from './modules/news-center'
// 解决方案
import solution from './modules/solution'
// 产品服务
import productService from './modules/product-service'
// 财税沙龙
import salonTax from './modules/salon-tax'
// 华盟招聘
import inviteJob from './modules/invite-job'
import H5 from './modules/h5'

const comMeta = { lang: 'zh' }

const routes = [
  {
    path: '/',
    name: 'hm-web',
    component: pageView,
    redirect: { name: 'home' },
    children: [
      {
        path: '/home',
        name: `home`,
        component: () => import('@/views/home/index'),
        meta: {
          ...comMeta,
          title: '首页',
          metaInfo: {
            title: '华盟·税纪云_官网首页'
          }
        }
      },
      {
        path: '/product/:type',
        name: `product`,
        component: () => import('@/views/product/index'),
        meta: {
          ...comMeta,
          title: '产品介绍'
        }
      },
      {
        path: '/service/:type',
        name: `service`,
        component: () => import('@/views/service/index'),
        meta: {
          ...comMeta,
          title: '服务介绍'
        }
      },
      {
        path: '/international',
        name: `international`,
        component: () => import('@/views/service/introduce/international'),
        meta: {
          ...comMeta,
          title: '服务介绍 - 企业走出去'
        }
      },
      {
        path: '/case',
        name: 'case',
        component: () => import('@/views/case/index'),
        meta: {
          ...comMeta,
          title: '行业案例'
        }
      },
      {
        path: '/case/details',
        name: 'caseDetails',
        component: () => import('@/views/case/caseDetails'),
        meta: {
          ...comMeta,
          title: '行业详情',
          nav: 'case'
        }
      },
      {
        path: '/about',
        name: `about`,
        component: () => import('@/views/about/contact/index'),
        meta: {
          ...comMeta,
          title: '关于华盟 - 联系我们',
          metaInfo: {
            title: '联系我们'
          }
        }
      },
      {
        path: '/introduce',
        name: `introduce`,
        component: () => import('@/views/about/introduce/index'),
        meta: {
          ...comMeta,
          title: '关于华盟 - 华盟介绍',
          metaInfo: {
            title: '华盟介绍'
          }
        }
      },
      {
        path: '/privacy',
        name: `privacy`,
        component: () => import('@/views/privacy'),
        meta: {
          ...comMeta,
          title: '隐私政策'
        }
      },
      {
        path: '/tryOut',
        name: `tryOut`,
        component: () => import('@/views/tryOut'),
        meta: {
          ...comMeta,
          title: '欢迎试用',
          metaInfo: {
            title: '申请试用'
          }
        }
      },
      {
        path: '/cfo',
        name: `cfo`,
        component: () => import('@/views/cfo'),
        meta: {
          ...comMeta,
          title: '欢迎购买',
          metaInfo: {
            title: '线上购买'
          }
        }
      },
      ...salonTax,
      ...newsCenter,
      ...solution,
      ...productService,
      ...inviteJob
    ]
  },
  {
    path: '/onboard-tryOut',
    name: `onboard-tryOut`,
    component: emptyView,
    children: [
      {
        path: '',
        name:'tryout-onboard',
        component: () => import('@/views/tryOut'),
        meta: {
          ...comMeta,
          title: '欢迎试用',
          metaInfo: {
            title: '申请试用'
          }
        }
      }
    ]
  },
  {
    path: '/pjy',
    name: `pjy`,
    component: () => import('@/views/pjy/index'),
    meta: {
      ...comMeta
    }
  },
  {
    path: '/apply',
    name: 'apply',
    component: emptyView,
    children: [
      {
        path: '',
        name: 'whitePaper_2022',
        component: () => import('@/views/apply/index'),
        meta: {
          ...comMeta,
          title: '申请白皮书',
          metaInfo: {
            title: '2022年企业税务数字化转型趋势洞察报告',
            meta: [
              {
                name: 'keywords',
                content: '深圳市注册税务师协会-智慧税务专家委员会'
              },
              {
                name: 'description',
                content: '专家库成员 主编'
              }
            ]
          }
        }
      },
      {
        path: '/apply_tax',
        name: 'taxPolicy_2023',
        component: () => import('@/views/apply/index'),
        meta: {
          ...comMeta,
          title: '税务政策',
          metaInfo: {
            title: '2022年企业税务数字化转型趋势洞察报告',
            meta: [
              {
                name: 'keywords',
                content: '深圳市注册税务师协会-智慧税务专家委员会'
              },
              {
                name: 'description',
                content: '专家库成员 主编'
              }
            ]
          }
        }
      }
    ]
  },
  ...H5
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js